import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Records as RecordsList } from '@components/Records/Records'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'

export const Records = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Records'))
  })

  const handleNavigate = () => {
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })
  }

  return <RecordsList handleNavigate={handleNavigate} />
}
